// src/services/CountryService.js
import api from "./api";

export function getIntake(page = 1, limit = 10, search = "") {
    return api.get(`/intake?page=${page}&limit=${limit}&search=${search}`);
}

export function getIntakeById(id) {
    return api.get(`/intake/${id}`);
}

export function addIntake(data) {
    return api.post("/intake", data);
}

export function updateIntake(id, data) {
    return api.put(`/intake/${id}`, data);
}

export function deleteIntake(id) {
    return api.delete(`/intake/${id}`);
}
